import { render, staticRenderFns } from "./policyDocument-info.vue?vue&type=template&id=7213f267&scoped=true&"
import script from "./policyDocument-info.vue?vue&type=script&lang=js&"
export * from "./policyDocument-info.vue?vue&type=script&lang=js&"
import style0 from "./policyDocument-info.vue?vue&type=style&index=0&id=7213f267&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7213f267",
  null
  
)

export default component.exports